import Axios from "../utils/axios";
import { EmailType } from "../Enums/EmailEnum";

const axios = new Axios();

const PATH = "my-email-subscriptions";
const STAFF_PATH = "./emailUnsubscriber";

export type MyEmailSubscriptionsResponse = {
  id: string | null;
  personId: string;
  email: string;
  personName?: string;
  unsubscribedCategories: EmailType[];
  unsubscribedEventIds?: string[];
};

export const subscribeEmailUnsubscriberItem = async (payload: {
  id: string;
  removeCategory?: string;
  removeEventId?: string;
}): Promise<void> => {
  await axios.Patch(STAFF_PATH, payload);
};

export const getMyEmailSubscriptions =
  async (): Promise<MyEmailSubscriptionsResponse | null> => {
    try {
      const response = await axios.Get(PATH);
      return (response?.data as MyEmailSubscriptionsResponse) ?? null;
    } catch (error) {
      if ((error as any)?.response?.status === 401) {
        return null;
      }
      console.error("Error fetching my email subscriptions:", error);
      throw error;
    }
  };

export const putMyEmailSubscriptions = async (
  unsubscribedCategories: EmailType[]
): Promise<MyEmailSubscriptionsResponse> => {
  const response = await axios.PutDataIntoModel(PATH, {
    unsubscribedCategories,
  });
  return response?.data as MyEmailSubscriptionsResponse;
};

export const getEmailSubscriptionsByPersonId = async (
  personId: string
): Promise<MyEmailSubscriptionsResponse> => {
  const response = await axios.Get(
    `${STAFF_PATH}?personId=${encodeURIComponent(personId)}`
  );
  return response?.data as MyEmailSubscriptionsResponse;
};

export const putEmailSubscriptionsByPersonId = async (
  personId: string,
  unsubscribedCategories: EmailType[]
): Promise<MyEmailSubscriptionsResponse> => {
  const response = await axios.PutDataIntoModel(STAFF_PATH, {
    personId,
    unsubscribedCategories,
  });
  return response?.data as MyEmailSubscriptionsResponse;
};
